/**
 * @generated SignedSource<<4016d323fd6346ae5281e4130173ffaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AppClipActionTitle = "OPEN" | "VIEW" | "%future added value";
export type AppStoreCategory = "BOOKS" | "BUSINESS" | "DEVELOPER_TOOLS" | "EDUCATION" | "ENTERTAINMENT" | "FINANCE" | "FOOD_AND_DRINK" | "GAMES" | "GRAPHICS_AND_DESIGN" | "HEALTH_AND_FITNESS" | "LIFESTYLE" | "MAGAZINES_AND_NEWSPAPERS" | "MEDICAL" | "MUSIC" | "NAVIGATION" | "NEWS" | "PHOTO_AND_VIDEO" | "PRODUCTIVITY" | "REFERENCE" | "SHOPPING" | "SOCIAL_NETWORKING" | "SPORTS" | "STICKERS" | "TRAVEL" | "UTILITIES" | "WEATHER" | "%future added value";
export type DescoperTaskStatus = "FAILURE" | "NOT_FOUND" | "PENDING" | "RUNNING" | "SUCCESS" | "%future added value";
export type useBrandGenerateScreensAsyncMutationGetStatusQuery$variables = {
  taskKey: string;
};
export type useBrandGenerateScreensAsyncMutationGetStatusQuery$data = {
  readonly screensGenerationTaskStatus: {
    readonly error: string | null;
    readonly result: {
      readonly account: {
        readonly deletionDialogTitle: string;
        readonly deletionSubtitle: string;
        readonly registerSubtitle: string;
        readonly registerTitle: string;
        readonly signInSubtitle: string;
        readonly signInTitle: string;
      } | null;
      readonly appListing: {
        readonly appClipButtonText: AppClipActionTitle;
        readonly appClipHeader: ReadonlyArray<string> | null;
        readonly appClipSubtitle: string;
        readonly appDescription: string;
        readonly appIcon: ReadonlyArray<string> | null;
        readonly appSubtitle: string;
        readonly keywords: string;
        readonly primaryCategory: AppStoreCategory;
        readonly promotionalText: string;
        readonly secondaryCategory: AppStoreCategory;
      } | null;
      readonly automation: {
        readonly abandonedBrowseNotifications: ReadonlyArray<{
          readonly message: string;
          readonly title: string;
        }>;
        readonly abandonedCartNotifications: ReadonlyArray<{
          readonly message: string;
          readonly title: string;
        }>;
        readonly abandonedCheckoutNotifications: ReadonlyArray<{
          readonly message: string;
          readonly title: string;
        }>;
        readonly reengagementNotifications: ReadonlyArray<{
          readonly landingPath: string;
          readonly message: string;
          readonly title: string;
        }>;
        readonly welcomeSeriesNotifications: ReadonlyArray<{
          readonly landingPath: string;
          readonly message: string;
          readonly title: string;
        }>;
      } | null;
      readonly notificationOptIn: {
        readonly backgroundImage: ReadonlyArray<string> | null;
        readonly subtitle: string;
        readonly title: string;
      } | null;
      readonly onboarding: {
        readonly backgroundImage: ReadonlyArray<string> | null;
        readonly rootTitle: string;
        readonly upsellSubtitle: string;
        readonly upsellTitle: string;
      } | null;
    } | null;
    readonly status: DescoperTaskStatus;
  };
};
export type useBrandGenerateScreensAsyncMutationGetStatusQuery = {
  response: useBrandGenerateScreensAsyncMutationGetStatusQuery$data;
  variables: useBrandGenerateScreensAsyncMutationGetStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskKey"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundImage",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v3/*: any*/)
],
v5 = [
  (v1/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "landingPath",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskKey",
        "variableName": "taskKey"
      }
    ],
    "concreteType": "ScreensGenerationTaskStatusResponse",
    "kind": "LinkedField",
    "name": "screensGenerationTaskStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GenerateScreensTextContentResponse",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationOptInTextResponse",
            "kind": "LinkedField",
            "name": "notificationOptIn",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subtitle",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OnboardingTextResponse",
            "kind": "LinkedField",
            "name": "onboarding",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rootTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "upsellTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "upsellSubtitle",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountTextResponse",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deletionDialogTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deletionSubtitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "registerTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "registerSubtitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signInTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signInSubtitle",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AutomationTextResponse",
            "kind": "LinkedField",
            "name": "automation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BaseNotificationResponse",
                "kind": "LinkedField",
                "name": "abandonedCartNotifications",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BaseNotificationResponse",
                "kind": "LinkedField",
                "name": "abandonedBrowseNotifications",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BaseNotificationResponse",
                "kind": "LinkedField",
                "name": "abandonedCheckoutNotifications",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationWithLandingPathResponse",
                "kind": "LinkedField",
                "name": "welcomeSeriesNotifications",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationWithLandingPathResponse",
                "kind": "LinkedField",
                "name": "reengagementNotifications",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AppListingTextResponse",
            "kind": "LinkedField",
            "name": "appListing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appSubtitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "promotionalText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "keywords",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appClipSubtitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appClipButtonText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryCategory",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secondaryCategory",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appClipHeader",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appIcon",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBrandGenerateScreensAsyncMutationGetStatusQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBrandGenerateScreensAsyncMutationGetStatusQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "34c65e98108f2a6f8663be7ef58ae32b",
    "id": null,
    "metadata": {},
    "name": "useBrandGenerateScreensAsyncMutationGetStatusQuery",
    "operationKind": "query",
    "text": "query useBrandGenerateScreensAsyncMutationGetStatusQuery(\n  $taskKey: String!\n) {\n  screensGenerationTaskStatus(taskKey: $taskKey) {\n    status\n    error\n    result {\n      notificationOptIn {\n        title\n        subtitle\n        backgroundImage\n      }\n      onboarding {\n        rootTitle\n        upsellTitle\n        upsellSubtitle\n        backgroundImage\n      }\n      account {\n        deletionDialogTitle\n        deletionSubtitle\n        registerTitle\n        registerSubtitle\n        signInTitle\n        signInSubtitle\n      }\n      automation {\n        abandonedCartNotifications {\n          title\n          message\n        }\n        abandonedBrowseNotifications {\n          title\n          message\n        }\n        abandonedCheckoutNotifications {\n          title\n          message\n        }\n        welcomeSeriesNotifications {\n          title\n          message\n          landingPath\n        }\n        reengagementNotifications {\n          title\n          message\n          landingPath\n        }\n      }\n      appListing {\n        appSubtitle\n        promotionalText\n        appDescription\n        keywords\n        appClipSubtitle\n        appClipButtonText\n        primaryCategory\n        secondaryCategory\n        appClipHeader\n        appIcon\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e969c00bf6812ba0895965a4d23d7a23";

export default node;
